import { updateQuizProgress } from '@/data/services/activityElement/quizProgressServices';
import {
  createActivityProgressAttempt,
  getActivityProgressAttempt,
} from '@/data/services/activityProgressAttemptServices';
import ActivityProgress, {
  QuizActivityAttempt,
} from '@/models/_deprecated/ActivityProgress';
import { QuizProgress } from '@/utils/editorjs/activity-block';
import { AlternativeRaw } from '@/utils/editorjs/activity-block/model/alternative';
import { QuizRaw } from '@/utils/editorjs/activity-block/model/quiz';
import { useActivityTool } from './useActivityTool';

export const useActivityToolWithProgress = (
  getActivityProgress: (quiz: QuizRaw) => Promise<ActivityProgress | undefined>,
  onChange?: () => Promise<void>,
) => {
  const onCheckAnswer = async (answer: AlternativeRaw, quiz: QuizRaw) => {
    const activityProgress = await getActivityProgress(quiz);

    const quizProgressId = activityProgress?.questionsProgress?.[0]?.progressId;

    if (!quizProgressId || !activityProgress) return;

    await updateQuizProgress(
      {
        quizId: quiz.id,
        quizProgressId: quizProgressId,
      },
      {
        answer: answer.verifier,
        isDone: true,
      },
    );

    await createActivityProgressAttempt(activityProgress.id);
    await onChange?.();
  };

  const getProgress = async (
    quiz: QuizRaw,
  ): Promise<QuizProgress | undefined> => {
    const activityProgress = await getActivityProgress(quiz);

    const bestAttempt = activityProgress?.bestAttempt;

    if (!activityProgress || !bestAttempt) return undefined;

    const attempt = await getActivityProgressAttempt({
      activityProgressId: activityProgress?.id,
      attemptId: bestAttempt.id,
    });

    const attemptContent = attempt.content?.[0] as QuizActivityAttempt;

    if (!attemptContent) return undefined;

    return {
      answer: attemptContent.answers.answer ?? '',
      isCorrect: attemptContent.answers.isCorrect,
      isDone: attemptContent.answers.isDone,
    };
  };

  return useActivityTool({
    getProgress,
    onCheckAnswer,
    randomize: true,
  });
};
